import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=1ac28163&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=1ac28163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac28163",
  null
  
)

export default component.exports